import './bluemacaw/style';
import FormStructure from './bluemacaw/form_structure';

export default FormStructure;